import { EventDispatcher } from '@sg-core/resources/assets/js/utils';

import { Menu } from './menu';

export const menuInstances = new WeakMap<HTMLElement, Menu>();

export const MENU_STATE_EVENTS = {
  UPDATE_PATH: 'updatePath',
  NEW_INSTANCE: 'newInstance',
} as const;

class MenuState extends EventDispatcher {
  private static openPaths: HTMLElement[] = [];
  private static menuInstances = new WeakMap<HTMLElement, Menu>();

  public setPaths(openPaths: HTMLElement[] | Set<HTMLElement>) {
    const oldPaths = [...MenuState.openPaths];

    if (Array.isArray(openPaths)) {
      MenuState.openPaths = openPaths;
    } else {
      MenuState.openPaths = Array.from(openPaths);
    }

    this.dispatchEvent(MENU_STATE_EVENTS.UPDATE_PATH, { oldPaths: new Set(oldPaths), newPaths: new Set(openPaths) });
  }

  public getPaths() {
    return new Set(MenuState.openPaths);
  }

  public addInstance(element: HTMLElement, instance: Menu) {
    MenuState.menuInstances.set(element, instance);

    this.dispatchEvent(MENU_STATE_EVENTS.NEW_INSTANCE, { element, instance });
  }

  public getInstance(el: HTMLElement) {
    return MenuState.menuInstances.get(el);
  }
}

export const menuState = new MenuState();
